var map = {
	"./placeholder.png": "9a4d",
	"./t1-email.png": "cad1",
	"./t1-endorsement-list.png": "0787",
	"./t1-endorsement-statement.png": "f7be",
	"./t1-events.png": "2697",
	"./t1-feature-text.png": "769d",
	"./t1-headshot.png": "ff65",
	"./t1-home-headshot.png": "bbdd",
	"./t1-intro-text.png": "4421",
	"./t1-media-block.png": "9d87",
	"./t1-name.png": "93c3",
	"./t1-open-content.png": "03f5",
	"./t1-petition.png": "3490",
	"./t1-position.png": "117d",
	"./t1-social-links.png": "3868",
	"./t2-email.png": "9991",
	"./t2-endorsement-list.png": "09d1",
	"./t2-endorsement-statement.png": "b0c2",
	"./t2-events.png": "08f1",
	"./t2-feature-text.png": "edc2",
	"./t2-headshot.png": "3adf",
	"./t2-intro-text.png": "4f63",
	"./t2-media-block.png": "2ca6",
	"./t2-name.png": "e522",
	"./t2-open-content.png": "7e63",
	"./t2-petition.png": "4b0c",
	"./t2-position.png": "752e",
	"./t2-social-links.png": "7c1b",
	"./t3-email.png": "8202",
	"./t3-endorsement-list.png": "04a4",
	"./t3-endorsement-statement.png": "bc47",
	"./t3-events.png": "0f57",
	"./t3-feature-text.png": "dc6d",
	"./t3-headshot.png": "04c2",
	"./t3-intro-text.png": "1bb7",
	"./t3-media-block.png": "4d5c",
	"./t3-name.png": "fcec",
	"./t3-open-content.png": "0e16",
	"./t3-petition.png": "0611",
	"./t3-position.png": "5720",
	"./t3-social-links.png": "9f57",
	"./t4-email.png": "e9a8",
	"./t4-endorsement-list.png": "cc04",
	"./t4-endorsement-statement.png": "668d",
	"./t4-events.png": "0035",
	"./t4-feature-image.png": "1397",
	"./t4-feature-text.png": "0cac",
	"./t4-headshot.png": "48b0",
	"./t4-intro-text.png": "0562",
	"./t4-media-block.png": "577c",
	"./t4-name.png": "80fb",
	"./t4-open-content.png": "2283",
	"./t4-petition.png": "40e1",
	"./t4-position.png": "73dc",
	"./t4-social-links.png": "d6d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5dd";